import { render, staticRenderFns } from "./ContainerRichTextKlv3.vue?vue&type=template&id=4edc14bd&scoped=true"
import script from "./ContainerRichTextKlv3.vue?vue&type=script&lang=js"
export * from "./ContainerRichTextKlv3.vue?vue&type=script&lang=js"
import style0 from "./ContainerRichTextKlv3.vue?vue&type=style&index=0&id=4edc14bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc14bd",
  null
  
)

export default component.exports